import React, { useState } from 'react';
import PropTypes from 'prop-types';

import noContentImage from 'common/images/noDocument.svg';
import imagePDF from 'backoffice/users/_components/UserDocument/imagePDF.svg';
import imageMSWord from 'backoffice/users/_components/UserDocument/imageMSWord.svg';
import { staticStyles } from './style';

const DocumentItem = ({ doc, fileUrl, isImage, isPDF, isWord }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div
        className={`Document__item Document__item--${doc.status}`}
        onClick={() => {
          if (isImage && fileUrl) {
            setShowModal(true);
          } else if ((isPDF || isWord) && fileUrl) {
            // Create a temporary link and trigger download
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = `document_${doc.id}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            if (isImage && fileUrl) {
              setShowModal(true);
            } else if ((isPDF || isWord) && fileUrl) {
              // Create a temporary link and trigger download
              const link = document.createElement('a');
              link.href = fileUrl;
              link.download = `document_${doc.id}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }}
        role="button"
        tabIndex={0}>
        <div className="Document__item-preview">
          {isImage && fileUrl ? (
            <img src={fileUrl} alt={`Document ${doc.id}`} />
          ) : isPDF && fileUrl ? (
            <img src={imagePDF} alt="PDF Document" />
          ) : isWord && fileUrl ? (
            <img src={imageMSWord} alt="Word Document" />
          ) : (
            <div className="Document__item-placeholder">
              <img src={noContentImage} alt="No document" />
            </div>
          )}
        </div>
        <style jsx>{staticStyles}</style>
      </div>

      {showModal && isImage && fileUrl && (
        <div
          className="Document__modal"
          onClick={() => setShowModal(false)}
          onKeyPress={e => e.key === 'Enter' && setShowModal(false)}
          role="button"
          tabIndex={0}>
          <div
            className="Document__modal-content"
            onClick={e => e.stopPropagation()}
            onKeyPress={e => e.key === 'Enter' && e.stopPropagation()}
            role="button"
            tabIndex={0}>
            <button className="Document__modal-close" onClick={() => setShowModal(false)} type="button">
              &times;
            </button>
            <img src={fileUrl} alt={`Document ${doc.id}`} />
          </div>
          <style jsx>{`
            .Document__modal {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.8);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1000;
            }

            .Document__modal-content {
              position: relative;
              max-width: 90%;
              max-height: 90%;
            }

            .Document__modal-content img {
              max-width: 100%;
              max-height: 80vh;
              object-fit: contain;
            }

            .Document__modal-close {
              position: absolute;
              top: -40px;
              right: 0;
              background: none;
              border: none;
              color: #fff;
              font-size: 30px;
              cursor: pointer;
            }
          `}</style>
        </div>
      )}
    </>
  );
};

DocumentItem.propTypes = {
  doc: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    file: PropTypes.object,
  }).isRequired,
  fileUrl: PropTypes.string,
  isImage: PropTypes.bool,
  isPDF: PropTypes.bool,
  isWord: PropTypes.bool,
};

DocumentItem.defaultProps = {
  fileUrl: null,
  isImage: false,
  isPDF: false,
  isWord: false,
};

export default DocumentItem;
